/* eslint-disable import/no-webpack-loader-syntax, no-underscore-dangle */
$(document).ready(() => {
  if ($('.contact-warranty-form').length === 0) {
    return;
  }

  // reload on partial postback
  const prm = Sys.WebForms.PageRequestManager.getInstance();
  if (prm != null) {
    prm.add_endRequest(() => {
      const button = $('.js-contactform-btn .FormButton');
      $(button).removeAttr('disabled', 'disabled');
    });

    prm.add_beginRequest(() => {
      const button = $('.js-contactform-btn .FormButton');
      $(button).attr('disabled', 'disabled');
    });
  }
});
